<template>
  <!-- <div id="map-location"></div> -->
  <div class="app">
    <div ref="map" id="map" style="width: 100%; height: 600px"></div>
  </div>
</template>
<script>
import { lazyAMapApiLoaderInstance } from "vue-amap";
import carUrl from "../../assets/images/car1.png";
import shipUrl from "../../assets/images/船ship.png";
var map;
export default {
  data() {
    return {
      navgtrSpeed: 10000, //播放速度
      navgtr: "",
      pathLsit: "",
      newList: "",
      imgUrl: "",
    };
  },
  mounted() {},
  created() {
    this.init();
  },
  props: ["linePath", "mapType", "status"],
  watch: {
    // 'linePath':function(){
    //   this.init();
    // },
    linePath: function (newVal, oldVal) {
      this.polylinePath = [];
      this.polylinePath = newVal;
      if (this.polylinePath.length > 1) {
        // this.init();
      }
    },
  },
  methods: {
    init(pathLsit, status, ship_car_type) {
      pathLsit
        ? (this.pathLsit = pathLsit)
        : (this.pathLsit = [
            {
              lng: 116.398012,
              lat: 39.905837,
            },
          ]);
      let self = this;
      let path = [];
      this.pathLsit.forEach((res) => {
        path.push([res.lng, res.lat, res.address, res.track_time]);
      });
      if (ship_car_type == "BOAT_TYPE") {
        this.imgUrl = shipUrl;
      } else {
        this.imgUrl = carUrl;
      }
      lazyAMapApiLoaderInstance.load().then(() => {
        //初始化地图
        map = new AMap.Map("map", {
          resizeEnable: true,
          zoom: 35,
          center: new AMap.LngLat(this.pathLsit[0].lng, this.pathLsit[0].lat), //
        });
        this.initPathSimplifier(path);
        this.PathSimplifier();
        if (status == "PositionEnd") {
          this.PathSimplifierEnd();
        }
      });
    },
    PathSimplifier() {
      //这个是添加AMapUI的点标注
      AMapUI.loadUI(["overlay/SimpleMarker"], (PathSimplifier) => {
        const marker = new PathSimplifier({
          iconLabel: "起",
          iconStyle: "red",
          color: "#fffff",
          map: map,
          radius: 5,
          position: [this.pathLsit[0].lng, this.pathLsit[0].lat],
          iconStyle: {
            src: "//webapi.amap.com/theme/v1.3/markers/b/mark_b.png",
            style: {
              width: "20px",
              height: "30px",
              color: "#f5f5f5",
            },
          },
        });
      });
    },
    PathSimplifierEnd() {
      //这个是添加AMapUI的点标注
      AMapUI.loadUI(["overlay/SimpleMarker"], (PathSimplifier) => {
        const marker = new PathSimplifier({
          iconLabel: "终",
          iconStyle: "black",
          color: "#fffff",
          map: map,
          radius: 5,
          position: [
            this.pathLsit[this.pathLsit.length - 1].lng,
            this.pathLsit[this.pathLsit.length - 1].lat,
          ],
          iconStyle: {
            src: "//webapi.amap.com/theme/v1.3/markers/b/mark_b.png",
            style: {
              width: "20px",
              height: "30px",
              color: "#f5f5f5",
            },
          },
        });
      });
    },
    initPathSimplifier(path) {
      let obj = {};
      AMapUI.load(["ui/misc/PathSimplifier", "lib/$"], (PathSimplifier, $) => {
        if (!PathSimplifier.supportCanvas) {
          alert("当前环境不支持 Canvas！");
          return;
        }
        var defaultRenderOptions = {
          //设置颜色
          renderAllPointsIfNumberBelow: 1000, //绘制路线节点，如不需要可设置为-1
          pathTolerance: 0,
          keyPointTolerance: 0,
          pathLineStyle: {
            //设置显示路线的颜色
            lineWidth: 6,
            strokeStyle: "#3399FF",
            borderWidth: 1,
            borderStyle: "#eeeeee",
            dirArrowStyle: true,
          },
          keyPointStyle: {
            //设置定位点的颜色
            radius: 3,
            fillStyle: "#ffffff",
            lineWidth: 1,
            strokeStyle: "#ff5252",
          },
          // pathLineSelectedStyle: {
          //   //设置鼠标悬停的颜色
          //   lineWidth: 6,
          //   strokeStyle: "#f1ff1b",
          //   borderWidth: 1,
          //   borderStyle: "#f01515",
          //   dirArrowStyle: true
          // },
          dirArrowStyle: {
            stepSpace: 35,
            strokeStyle: "#ffffff",
            lineWidth: 2,
          },
          pathNavigatorStyle: {
            initRotateDegree: 0,
            width: 20,
            height: 40,
            autoRotate: true,
            lineJoin: "round",
            content: PathSimplifier.Render.Canvas.getImageContent(
              this.imgUrl,
              onload,
              onerror
            ),
            fillStyle: "#159ef0",
            strokeStyle: "#1b9deb",
            lineWidth: 1,
            pathLinePassedStyle: {
              //设置轨迹颜色
              lineWidth: 3,
              strokeStyle: "#66CCFF",
              borderWidth: 1,
              borderStyle: "#eeeeee",
              dirArrowStyle: true,
            },
          },
        };
        var pathSimplifierIns = new PathSimplifier({
          zIndex: 100,
          //autoSetFitView:false,
          map: map, //所属的地图实例

          getPath: function (pathData, pathIndex) {
            return pathData.path;
          },

          getHoverTitle: function (pathData, pathIndex, pointIndex) {
            if (pointIndex >= 0) {
              //point
              return (
                // pathData.name +
                // "，点：" +
                // pointIndex +
                // "/" +
                // pathData.path[2]
                // pathData.name +
                "经点" +
                pointIndex +
                "：" +
                pathData.path[pointIndex][3] +
                "," +
                pathData.path[pointIndex][2]
              );
            }

            // return pathData.name + "，点数量" + pathData.path.length;
          },
          renderOptions: defaultRenderOptions,
        });
        // 这里是设置数据
        pathSimplifierIns.setData([
          {
            name: "路线0",
            path: path,
          },
        ]);
        this.pathLsit.forEach((item, i) => {
          if (i != 0) {
            var marker = new AMap.Marker({
              position: new AMap.LngLat(item.lng, item.lat),
              icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png", // 添加 Icon 图标 URL
              offset: new AMap.Pixel(-12, -32),
              title: "",
            });
            marker.setTitle(
              "途经点" + i + "：" + item.track_time + "," + item.address
            );
            marker.setMap(map);
          }
        });
        //对第一条线路（即索引 0）创建一个巡航器
        this.navgtr = pathSimplifierIns.createPathNavigator(0, {
          loop: false, //循环播放
          speed: this.navgtrSpeed, //巡航速度，单位千米/小时
        });
        this.navgtr.start();
        this.PathSimplifier();
      });
    },
    //播放的方法
    play() {
      this.navgtr.start();
    },
    //暂停的方法
    suspend() {
      this.navgtr.pause();
    },
    // 恢复的方法
    recover() {
      this.navgtrSpeed = 10000;
      this.navgtr.resume();
    },
    //倍数的方法
    add(val) {
      if (val) {
        this.navgtrSpeed = 10000 * val;
      }
      this.navgtr.setSpeed(this.navgtrSpeed);
    },
  },
};
</script>
<style>
#map-location {
  width: 100%;
  height: 500px;
}
.amap-icon img {
  width: 25px;
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/map/amap-line.vue